export const MAX_TIP_TOP_SUPPORTERS = 3;
export const TIPPING_MESSAGE_MAX_LENGTH = 90;
export const TIP_THANK_YOU_MESSAGE = 'tipThankYouMessage';
export const THANK_YOU_MESSAGE = 'I’m able to do what I love because of people like you. Thank you for your support.';
export const SUCCESS_VIEW_SCREEN_TIME = 10000;
